// @ts-nocheck
import React, { FC } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import constants from "@store/constants";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Zone from "@insite/client-framework/Components/Zone";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import { useSession } from "@toolkit/Framework/Store/Context/ContextHooks";

const enum fields {
    customerTypes = "customerTypes",
}

const enum customerTypeFields {
    productLine = "productLine",
}

export interface CustomerTypeProps {
    fields: {
        [customerTypeFields.productLine]: string;
    };
}

export interface RestrictedContentProps extends WidgetProps {
    id: string;
    fields: {
        [fields.customerTypes]: CustomerTypeProps[];
    };
}

const RestrictedContent: FC<RestrictedContentProps> = ({ id, fields }) => {
    const { customerTypes } = fields;

    if (!customerTypes?.length) {
        return null;
    }

    const { isEditing } = useShellContext();
    const session = useSession();

    const currentCustomerTypes = session?.properties?.customerTypes || "";
    const currentTypesArray = currentCustomerTypes ? JSON.parse(currentCustomerTypes) : [];

    const hasAccess =
        customerTypes.some(
            ({ fields: ct }) => ct.productLine === "All" || currentTypesArray.includes(ct.productLine),
        ) || isEditing;

    return hasAccess ? <Zone zoneName="RestrictedContent" contentId={id} /> : null;
};

const widgetModule: WidgetModule<Toolkit.FieldDefinition> = {
    component: RestrictedContent,
    definition: {
        group: constants.widgetGroup.layout,
        displayName: "Restricted Content Wrapper",
        icon: "",
        fieldDefinitions: [
            {
                name: fields.customerTypes,
                displayName: "Customer Types",
                editorTemplate: "ListField",
                defaultValue: [],
                fieldType: "General",
                tooltip: "Select the customer type(s) that should have access to the content within this wrapper.",
                getDisplay: x => x.fields.productLine || "Product Line",
                fieldDefinitions: [
                    {
                        name: customerTypeFields.productLine,
                        displayName: "Product Line restriction",
                        editorTemplate: "DropDownField",
                        options: [
                            { displayName: "No product line restriction", value: "All" },
                            { displayName: "Valve customers", value: "valves" },
                            { displayName: "Krebs Express pump customers", value: "krebs express pumps" },
                            { displayName: "DOE pump customers", value: "doe pumps" },
                            { displayName: "Cyclone customers", value: "cyclones" },
                        ],
                        defaultValue: "All",
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
